
<template>
    <Tab3Comp />
  </template>
  
  <script>
  import Tab3Comp from '@/components/RecruitmentTab3.vue';
  
    export default {
        name: "Tab3Vue",
        components: {
            Tab3Comp
        }
    }
  
  </script>